import styled from "styled-components";

const desktop = 920;

export const HomeContainer = styled.div``;

export const HeaderMisenscene = styled.section`
  margin: 20px auto 35px;
  @media (min-width: ${desktop}px) {
    width: 70%;
    overflow: visible;
    .slick-slide {
      img {
        height: 70vh;
        width: 100%;
        object-fit: cover;
        object-position: top;
      }
    }

    .slick-dots li button:before {
      font-size: 12px;
    }
  }
`;

export const AboutMisenscene = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2em 0;
  p {
    width: 70%;
  }
`;

export const BtnPortfolio = styled.a`
  text-decoration: none;
  border: none;
  font-size: 24px;
  background-color: #2b2ab8;
  padding: 0.6em;
  color: white;
  opacity: 0.8;
  transition: opacity 0.4s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;
